"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.VernacularNameFactory = exports.TaxonFactory = exports.TaxonomyFactory = void 0;
var utils_1 = require("../utils");
exports.TaxonomyFactory = {
    createInstance: function (params) {
        var defaultProps = {
            props: {},
            published: false,
            draft: true
        };
        var _a = __assign(__assign({}, defaultProps), params), props = _a.props, draft = _a.draft, published = _a.published;
        return {
            uuid: utils_1.UUIDs.v4(),
            props: props,
            draft: draft,
            published: published
        };
    }
};
exports.TaxonFactory = {
    createInstance: function (params) {
        var defaultProps = {
            props: {},
            vernacularNames: {}
        };
        var _a = __assign(__assign({}, defaultProps), params), props = _a.props, taxonomyUuid = _a.taxonomyUuid, vernacularNames = _a.vernacularNames;
        return {
            uuid: utils_1.UUIDs.v4(),
            props: props,
            taxonomyUuid: taxonomyUuid,
            vernacularNames: vernacularNames
        };
    }
};
exports.VernacularNameFactory = {
    createInstance: function (params) {
        var lang = params.lang, name = params.name;
        return {
            uuid: utils_1.UUIDs.v4(),
            props: {
                lang: lang,
                name: name
            }
        };
    }
};
//# sourceMappingURL=factory.js.map